import { components } from 'gridstrap/lib/gs-components';
import { GSHorizontalScroller } from './horizontal-scroller';

import './horizontal-scroller.scss';

components.register({
	selector: '.gs-HorizontalScroller',
	controller: GSHorizontalScroller
});
